module.exports = __webpack_public_path__ + "static/media/img-about-image@2x.3e651c1d.jpg";